<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
    name: 'BarChart',
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object,
        },
        chartOptions: {
            type: Object,
        },
    },

    mounted() {
        this.renderChart(this.chartData, this.chartOptions);
    },
};
</script>
